import creativity1 from '../assets/gallary/smart/1.jpeg';
import creativity2 from '../assets/gallary/smart/2.jpeg';
import creativity3 from '../assets/gallary/smart/3.jpeg';
import creativity4 from '../assets/gallary/smart/4.jpeg';
import creativity5 from '../assets/gallary/smart/5.jpeg';
import creativity6 from '../assets/gallary/smart/6.jpeg';
import creativity7 from '../assets/gallary/smart/7.jpeg';
import creativity8 from '../assets/gallary/smart/8.jpeg';
import creativity9 from '../assets/gallary/smart/9.jpeg';
import creativity12 from '../assets/gallary/smart/12.jpeg';
import creativity13 from '../assets/gallary/smart/IMG-20250706-WA0005.jpg';
import creativity14 from '../assets/gallary/smart/IMG-20250706-WA0006.jpg';
import creativity15 from '../assets/gallary/smart/IMG-20250706-WA0007.jpg';
import creativity16 from '../assets/gallary/smart/IMG-20250706-WA0008.jpg';
import creativity17 from '../assets/gallary/smart/IMG-20250706-WA0009.jpg';
import creativity18 from '../assets/gallary/smart/IMG-20250706-WA0010.jpg';
import creativity19 from '../assets/gallary/smart/IMG-20250706-WA0013.jpg';
import creativity20 from '../assets/gallary/smart/WhatsApp Image 2025-07-06 at 23.04.07_d3debe48.jpg';

import festival6 from '../assets/gallary/smart1/6.jpeg';
import festival7 from '../assets/gallary/smart1/7.jpeg';
import festival8 from '../assets/gallary/smart1/8.jpeg';
import festival9 from '../assets/gallary/smart1/9.jpeg';
import festival10 from '../assets/gallary/smart1/10.jpeg';
import festival11 from '../assets/gallary/smart1/11.jpeg';
import festival12 from '../assets/gallary/smart1/IMG-20250706-WA0005.jpg';
import festival13 from '../assets/gallary/smart1/IMG-20250706-WA0006.jpg';
import festival14 from '../assets/gallary/smart1/IMG-20250706-WA0007.jpg';
import festival15 from '../assets/gallary/smart1/IMG-20250706-WA0008.jpg';
import festival16 from '../assets/gallary/smart1/IMG-20250706-WA0009.jpg';
import festival17 from '../assets/gallary/smart1/WhatsApp Image 2025-07-06 at 23.00.08_37dec3c8.jpg';


export const creativityGallary = [
    { id: 1, image: creativity1 },
    { id: 2, image: creativity2 },
    { id: 3, image: creativity3 },
    { id: 4, image: creativity4 },
    { id: 5, image: creativity5 },
    { id: 6, image: creativity6 },
    { id: 7, image: creativity7 },
    { id: 8, image: creativity8 },
    { id: 9, image: creativity9 },
    { id: 12, image: creativity12 },
    { id: 13, image: creativity13 },
    { id: 14, image: creativity14 },
    { id: 15, image: creativity15 },
    { id: 16, image: creativity16 },
    { id: 17, image: creativity17 },
    { id: 18, image: creativity18 },
    { id: 19, image: creativity19 },
    { id: 20, image: creativity20 },
];

export const festivalGallary = [
    { id: 6, image: festival6 },
    { id: 7, image: festival7 },
    { id: 8, image: festival8 },
    { id: 9, image: festival9 },
    { id: 10, image: festival10 },
    { id: 11, image: festival11 },
    { id: 12, image: festival12 },
    { id: 13, image: festival13 },
    { id: 14, image: festival14 },
    { id: 15, image: festival15 },
    { id: 16, image: festival16 },
    { id: 17, image: festival17 },
];
